module.exports = __webpack_public_path__ + "img/0Q3A2361_L_Wood.885dfe3d.jpg";